<style>

.dt-container{
  display: grid;
  grid-template-columns: auto 32px auto 32px;
}
.date{
  grid-column: 1;
}
.arrow1{
  grid-column: 2;
  text-align: center;
  font-size: 23px;
  border-right: 1px gray solid;
}
.time{
  grid-column: 3;
  margin-left: 10px;
}
.arrow2{
  grid-column: 4;
  text-align: center;
  font-size: 23px;
}

</style>

<div class="dt-container">
  <div class="date" on:click="{ () => dispatch('showCalendar') }">{ parseDate(datetime) }</div>
  <div class="arrow1" on:click="{ () => dispatch('showCalendar') }"><i class="icon-keyboard_arrow_down"></i></div>
  <div class="time" on:click="{ () => dispatch('showTime') }">{ parseTime(datetime) }</div>
  <div class="arrow2" on:click="{ () => dispatch('showTime') }"><i class="icon-keyboard_arrow_down"></i></div>
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import DateTime from "../helpers/DateTime.js";


export let datetime = "2024-02-29 16:20:00";



function parseDate(datetime) {
  let date = new Date(datetime);
  return DateTime.date(date);
}


function parseTime(datetime) {
  let date = new Date(datetime);
  return DateTime.time(date);
}

</script>